<template>
	<div class="statusPage">
		<div v-if="showStatus === 0" class="content">
			<img src="~@/assets/siteSeoAnalysis/showStatus0.png" alt="" />
			<p class="text">网站还未上线，无法进行站点SEO分析，请先联系您的专属网建人员上线网站哦</p>
		</div>

		<div v-if="showStatus === 1" class="content">
			<img src="~@/assets/siteSeoAnalysis/showStatus1.png" alt="" />
			<p class="text">正在进行站内SEO分析，请稍候查看</p>
		</div>

		<div v-if="showStatus === 3" class="content">
			<img src="~@/assets/siteSeoAnalysis/showStatus3.png" alt="" />
			<p class="text">SEO分析失败，我们也在努力寻找原因，您可以点击重新分析</p>
			<el-button type="primary" @click="refresh">重新分析</el-button>
		</div>

		<div v-if="showStatus === 4" class="content">
			<img src="~@/assets/siteSeoAnalysis/showStatus4.png" alt="" />
			<p class="text">您的网站还未进行SEO分析</p>
			<el-button type="primary" @click="refresh">开始分析</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'statusPage',
	props: ['showStatus'],
	methods: {
		refresh() {
			this.$emit('refresh');
		},
	},
};
</script>

<style lang="scss" scoped>
.statusPage {
	height: calc(100vh - 245px);
	background-color: #fff;
	margin: 0 20px;
	display: flex;
	justify-content: center;
	align-items: center;

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		.text {
			font-size: 15px;
			font-weight: 500;
			color: #333333;
			margin: 20px 0;
		}
	}
}
</style>
